/* global runtime */
const updateInventoryCount = async ({ updates } = {}) => {
  if (!runtime.activeBusinessId) throw new Error(t('svc.pickBusiness'));
  const result = await authorizedPost('inventoryCountAdjustmentHttp', { businessId: runtime.activeBusinessId, updates });
  if (result.state) {
    runtime.appState = mergeAppMutationState(result.state);
    emitRuntime();
    window.dispatchEvent(new Event(BACKEND_EVENTS.products));
  }
  return result.adjustments || [];
};
